import React from 'react';
import { ShieldCheck, Download, Lock, Infinity as InfinityIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-white pt-8 pb-12 px-4 md:px-8" data-id="element-73">
      <div className="max-w-4xl mx-auto text-center" data-id="element-74">
        <h2 className="inline-block text-xs md:text-sm font-bold text-green-700 mb-4 uppercase tracking-widest bg-green-50 px-4 py-1.5 rounded-full shadow-[0_0_15px_rgba(22,163,74,0.3)]" data-id="element-75">
          PARA MAESTRAS DE CIENCIAS SOCIALES PRIMARIA
        </h2>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-black text-gray-900 leading-tight mb-8" data-id="element-76">
          Resolvé todo tu año de Ciencias Sociales en un solo lugar y olvidate
          de planificar desde cero con el{' '}
          <span className="text-green-600" data-id="element-77">
            Mega Pack Ciencias Sociales Lista
          </span>
        </h1>

        <div className="mb-4 flex justify-center" data-id="element-78">
          <img src="https://cdn.magicpatterns.com/uploads/vnsZWkGMa3WPtA9TyUdccB/MOCKUPS_CIENCIAS_SOCIALES_.png" alt="Mega Pack Ciencias Sociales Lista Completo" className="w-full max-w-2xl object-contain hover:scale-105 transition-transform duration-300 cursor-pointer" onClick={() => document.getElementById('compra')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-79" />
        </div>

        <div className="mb-8" data-id="element-80">
          <p className="text-base md:text-lg text-gray-600 font-normal mb-1" data-id="element-81">
            Sistema completo de clases, actividades y proyectos de Ciencias
            Sociales listos para usar.
          </p>
          <p className="text-base md:text-lg text-gray-600 font-normal flex items-center justify-center gap-1.5" data-id="element-82">
            <span className="text-green-600 text-sm" data-id="element-83">●</span>
            Todo tu año resuelto (todos los grados de primaria)
          </p>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-84">
          <a href="#compra" className="bg-green-600 hover:bg-green-700 text-white text-2xl md:text-3xl font-bold py-6 px-8 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 w-full max-w-2xl animate-pulse text-center" data-id="element-85">
            👉 SÍ, QUIERO ACCESO INMEDIATO
          </a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm md:text-base text-gray-600 font-medium" data-id="element-86">
            <div className="flex items-center gap-1" data-id="element-87">
              <Lock className="w-4 h-4 text-green-600" data-id="element-88" />
              <span data-id="element-89">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-90">
              <Download className="w-4 h-4 text-green-600" data-id="element-91" />
              <span data-id="element-92">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-93">
              <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-94" />
              <span data-id="element-95">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-96">
              <InfinityIcon className="w-4 h-4 text-green-600" data-id="element-97" />
              <span data-id="element-98">Acceso de por vida</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}